'use client';
import React from 'react';
import ComparisonChart from './comparison-chart';
import { Button } from '@heroui/react';
import { useDisclosure } from '@heroui/modal';
import useOfferComparisonStore from '../store/use-offer-comparison-store';
import { useTranslations } from 'next-intl';
import ModalTemplate from './modal-template';
import { ReferenceTariffType } from '../types/reference-tariff-type';

export type PriceComparisonProps = {
  isGermanCustomer: boolean;
};
export default function PriceComparison({
  isGermanCustomer,
}: PriceComparisonProps) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const t = useTranslations('priceComparison');
  const offer = useOfferComparisonStore((state) => state.offer);
  const mode = useOfferComparisonStore((state) => state.mode);
  const hasInvoice = mode === ReferenceTariffType.invoice;

  if (offer == null) return;

  return (
    <div data-testid="priceComparisonCard">
      <div className="bg-[var(--color-card-primary)] rounded-3.75 py-8 outline outline-1 outline-[var(--color-border-default)] my-6">
        {hasInvoice && (
          <p
            data-testid="price-comparison-title"
            className="font-heading text-[28px] text-center leading-10"
          >
            {t('title')}
          </p>
        )}
        <div className="text-center pt-[14px] md:pt-2.5 pb-6">
          {hasInvoice && (
            <Button
              data-testid="price-comparison-subtitle-button"
              onPress={onOpen}
              className="text-base text-[var(--color-text-subtle)] bg-transparent underline font-medium"
            >
              <p data-testid="priceComparisonSubtitleBody">{t('subtitle')}</p>
            </Button>
          )}
          <ModalTemplate
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            title={hasInvoice ? t('subtitle') : ''}
          >
            {hasInvoice && (
              <p data-testid="price-comparison-subtitle-body">
                {t('subtitleBody')}
              </p>
            )}
          </ModalTemplate>
        </div>
        <ComparisonChart isGermanCustomer={isGermanCustomer} />
      </div>
    </div>
  );
}
